import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import partial from 'lodash/partial';
import { fetchAll, clearAll, setGrouping, getEntries } from 'focus_groups/ducks/entries';
import { getProject } from 'project/ducks/project';
import { getProjectIdFromUrl } from 'project/utils';
import { ENTRIES_RESOURCE_NAME } from 'focus_groups/constants';
import Entries from 'focus_groups/components/entries';

const mapStateToProps = (state) => {
  const { grouped, isFetching } = state.project.focusGroups.entries;
  const project = getProject(state);

  return {
    itemVariation: "focusGroupEntries",
    resourceName: ENTRIES_RESOURCE_NAME,
    entries: getEntries(state),
    project,
    grouped,
    isFetching,
  };
}

const mapDispatchToProps = (dispatch, { params, location }) => {
  const projectId = getProjectIdFromUrl(params);

  return bindActionCreators({
    fetch: partial(fetchAll, projectId, location.query),
    clear: clearAll,
    setGrouping
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Entries));



// WEBPACK FOOTER //
// ./focus_groups/containers/entries.js